var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"my-back-btn",attrs:{"depressed":""}},[_c('img',{staticClass:"back-btn",attrs:{"src":_vm.$store.state.icons.icons['LeftArrow']}}),_vm._v(" Back ")])
}
var staticRenderFns = []

export { render, staticRenderFns }